module.exports = __webpack_public_path__ + "static/media/ernesto-van-peborgh.3611353b.png";